/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash'
import classnames from 'classnames'

import PostCard from '../post-card'

import css from './post-card-row.scss'

const PostCardRow = (props) => {
  const {
    className,
    featuredRow,
    hideLastPostSm,
    navigateWithRouter,
    posts,
    showTopics,
  } = props

  return (
    <div className={classnames(className, css.postCardRowContainer)}>
      {posts
        .filter((post) => post !== undefined)
        .map((post, idx) => [
          <PostCard
            className={classnames(
              {
                'visible-xs': hideLastPostSm && idx === posts.length - 1,
              },
              featuredRow ? css.postCardRowCardFeatured : css.postCardRowCard
            )}
            image={post.featuredImage ? post.featuredImage.url : null}
            key={`post_card_${post.id}`}
            navigateWithRouter={
              !isUndefined(navigateWithRouter) ? navigateWithRouter : true
            }
            post={post}
            teaserText={post.teaserText}
            title={post.title}
            topic={
              showTopics && post.meta.topics
                ? post.meta.topics.find((t) => t.slug === 'sponsored') ||
                  post.meta.topics[0]
                : null
            }
          />,
        ])}
    </div>
  )
}

PostCardRow.propTypes = {
  className: PropTypes.string,
  featuredRow: PropTypes.bool,
  navigateWithRouter: PropTypes.bool,
  posts: PropTypes.array.isRequired,
  showTopics: PropTypes.bool,
  hideLastPostSm: PropTypes.bool,
}

PostCardRow.defaultProps = {
  className: null,
  featuredRow: false,
  navigateWithRouter: false,
  hideLastPostSm: false,
  showTopics: true,
}

// eslint-disable-next-line import/no-default-export
export default PostCardRow
